var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.944 1060.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.028,21.354a8.317,8.317,0,1,0-8.319-8.317A8.317,8.317,0,0,0,128.028,21.354Z",
    transform: "translate(20.902 0.824)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.514,17.826s.146,4.815-3.065,6.274S134,25.413,134,25.413s-4.67-5.691-3.356-7.587Z",
    transform: "translate(21.131 3.113)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.514,17.826s.146,4.815-3.065,6.274S134,25.413,134,25.413s-4.67-5.691-3.356-7.587Z",
    transform: "translate(21.131 3.113)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.575,21.878a5.691,5.691,0,1,0-5.692-5.691A5.691,5.691,0,0,0,127.575,21.878Z",
    transform: "translate(21.282 1.833)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.886,22.514,123,21.42l-2.846,2.991-3.21.438,4.232,17.363-.146,4.377s-4.67,3.5-4.379,19.7-2.335,48.3.876,48.588,9.924,1.751,10.361.438S129.054,62.2,129.054,62.2s-.146,51.944,2.044,52.528,8.9,1.75,9.779-.146,0-51.361,0-51.361-.147-12.84-5.4-16.634l-.584-3.356,4.525-18.385h-3.648l-2.189-3.794-4.525,1.6Z",
    transform: "translate(20.239 3.676)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.321,39.23l-6.256,10.55s-4.574,4.693-2.285,5.989,4.723-5.464,4.723-5.464l6.729-8.858Z",
    transform: "translate(18.882 6.85)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.237,39.421l5.058,11.173s4.031,5.167,1.613,6.2-4.094-5.95-4.094-5.95L135.1,41.3Z",
    transform: "translate(23.589 6.883)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.121,25.306l-1.9-1.021s-3.357,5.545-2.773,14.883c0,0-.584,4.961.584,5.253s4.525.875,4.67.292,1.9-11.381,1.9-11.381Z",
    transform: "translate(19.959 4.24)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.692,25.015l1.751-.73a10.5,10.5,0,0,1,2.335,5.4c.438,3.356,2.482,14.153.876,14.445s-5.4.875-5.4,0-1.314-11.089-1.314-11.089Z",
    transform: "translate(23.213 4.24)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.138,11.311,128.917,9.1l-5.83.9-1.206,5.326,3-.115.839-1.957v1.924l1.385-.053.8-3.115.5,3.316,4.925-.1Z",
    transform: "translate(21.282 1.589)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.663,7.581a3.356,3.356,0,1,0-3.356-3.356A3.356,3.356,0,0,0,127.663,7.581Z",
    transform: "translate(21.705 0.152)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.713,3.356A3.355,3.355,0,0,1,126.557.039a3.356,3.356,0,1,0,0,6.635,3.355,3.355,0,0,1-2.845-3.317Z",
    transform: "translate(21.423 0)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,90.965c.791,0,1.432-.436,1.432-.975s-.641-.975-1.432-.975-1.432.436-1.432.975S76.506,90.965,77.3,90.965Z",
    transform: "translate(13.247 15.543)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.086,89.846s6.8,11.816,6.624,13.522Z",
    transform: "translate(13.46 15.688)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.321,90.54v6.912c-1.425-1.974-4.267-4.006-9.593-5.656l9.593,13.173v.1l.052-.029.016.022s.014-.018.038-.054C83.545,104.362,92.919,98.526,82.321,90.54Z",
    transform: "translate(12.699 15.809)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.786,102.684H76.32v.364h99.466Z",
    transform: "translate(13.326 17.93)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.682,103.412h-3.59V99.822h3.59Zm-3.314-.276h3.037V100.1H95.368Z",
    transform: "translate(16.604 17.43)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.439,100.246a1.832,1.832,0,1,0-1.834-1.832A1.833,1.833,0,0,0,155.439,100.246Z",
    transform: "translate(26.821 16.864)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.953,104.221a5.3,5.3,0,1,1,3.741-1.552A5.3,5.3,0,0,1,155.953,104.221Zm0-10.179a4.892,4.892,0,1,0,3.453,1.433A4.89,4.89,0,0,0,155.953,94.042Z",
    transform: "translate(26.306 16.35)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.95,6.214H5.572V79.3H127.95Z",
    transform: "translate(0.973 1.085)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.032,6.214,5.572,58.691V46.121L63.719,6.214Z",
    transform: "translate(0.973 1.085)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.676,6.214V7.484L14.046,79.3H5.572V72.544l96.644-66.33Z",
    transform: "translate(0.973 1.085)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.819,57.443h-.364V70.351h.364Z",
    transform: "translate(2.524 10.03)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.306,62.663a4.545,4.545,0,1,0-4.546-4.545A4.546,4.546,0,0,0,15.306,62.663Z",
    transform: "translate(1.879 9.354)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.336,48h-.364V72h.364Z",
    transform: "translate(6.281 8.382)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.823,53.687a4.545,4.545,0,1,0-4.546-4.545A4.545,4.545,0,0,0,36.823,53.687Z",
    transform: "translate(5.636 7.787)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.856,30.822h-.364V75h.364Z",
    transform: "translate(10.039 5.382)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.343,36.043A4.545,4.545,0,1,0,53.8,31.5,4.546,4.546,0,0,0,58.343,36.043Z",
    transform: "translate(9.393 4.706)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.373,42.121H79.01V73.026h.364Z",
    transform: "translate(13.796 7.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.86,47.341A4.545,4.545,0,1,0,75.314,42.8,4.545,4.545,0,0,0,79.86,47.341Z",
    transform: "translate(13.151 6.679)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.891,19.679h-.364V76.944h.364Z",
    transform: "translate(17.553 3.436)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.378,24.9a4.545,4.545,0,1,0-4.546-4.545A4.545,4.545,0,0,0,101.378,24.9Z",
    transform: "translate(16.908 2.76)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,57.288H5.572v.364H6.663Z",
    transform: "translate(0.973 10.003)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.085,57.652H11.376v-.364h1.709Zm-3.419,0H7.957v-.364H9.666Z",
    transform: "translate(1.389 10.003)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.868,57.288H13.777v.364h1.091Z",
    transform: "translate(2.406 10.003)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,48.311H5.572v.364H6.663Z",
    transform: "translate(0.973 8.436)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.063,48.675H34.857v-.364h2.206Zm-4.413,0H30.444v-.364H32.65Zm-4.413,0H26.031v-.364h2.206Zm-4.413,0H21.619v-.364h2.206Zm-4.413,0H17.206v-.364h2.206Zm-4.413,0H12.793v-.364H15Zm-4.413,0H8.381v-.364h2.206Z",
    transform: "translate(1.463 8.436)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.769,48.311H34.678v.364h1.091Z",
    transform: "translate(6.055 8.436)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,41.966H5.572v.364H6.663Z",
    transform: "translate(0.973 7.328)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.259,42.329h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0H56.7v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Zm-4.394,0h-2.2v-.364h2.2Z",
    transform: "translate(1.462 7.328)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.792,41.966H75.7v.364h1.091Z",
    transform: "translate(13.218 7.328)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,30.667H5.572v.364H6.663Z",
    transform: "translate(0.973 5.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.109,31.031H57.862v-.364h2.248Zm-4.495,0H53.366v-.364h2.248Zm-4.5,0H48.871v-.364h2.247Zm-4.495,0H44.376v-.364h2.248Zm-4.5,0H39.881v-.364h2.247Zm-4.495,0H35.386v-.364h2.248Zm-4.495,0H30.891v-.364h2.247Zm-4.5,0H26.4v-.364h2.248Zm-4.5,0H21.9v-.364h2.247Zm-4.5,0H17.406v-.364h2.247Zm-4.495,0H12.911v-.364h2.247Zm-4.5,0H8.416v-.364h2.247Z",
    transform: "translate(1.47 5.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.429,30.667H54.338v.364h1.091Z",
    transform: "translate(9.488 5.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,19.83l-1.091,0V20.2l1.091,0Z",
    transform: "translate(0.973 3.463)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333,20.239v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007V20.2Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014V19.75l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014V19.68l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014V19.61l2.15-.007v.364Zm4.3-.014V19.6l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014v-.364l2.15-.007v.364Zm4.3-.014V19.54l2.15-.007V19.9Z",
    transform: "translate(1.455 3.411)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,19.524l-1.091,0v.364l1.091,0Z",
    transform: "translate(17.435 3.409)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637,18.286H0v3.636H3.637Z",
    transform: "translate(0 3.193)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637,29.274H0V32.91H3.637Z",
    transform: "translate(0 5.112)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637,40.573H0v3.636H3.637Z",
    transform: "translate(0 7.084)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637,46.918H0v3.636H3.637Z",
    transform: "translate(0 8.192)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637,55.9H0v3.636H3.637Z",
    transform: "translate(0 9.76)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.664,56.684l2.4-9.143-9.146-2.4-2.4,9.143Z",
    transform: "translate(25.234 7.882)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.935,53.9a2.186,2.186,0,1,1,1.143,1.217A2.189,2.189,0,0,1,142.935,53.9Zm3.743-1.41a1.82,1.82,0,1,0-.046,1.39A1.817,1.817,0,0,0,146.678,52.491Z",
    transform: "translate(24.933 8.896)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.518,103.277c1.708,0,3.092-.733,3.092-1.636S123.226,100,121.518,100s-3.09.733-3.09,1.636S119.812,103.277,121.518,103.277Z",
    transform: "translate(20.679 17.462)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.594,103.277c1.707,0,3.09-.733,3.09-1.636S135.3,100,133.594,100s-3.092.733-3.092,1.636S131.886,103.277,133.594,103.277Z",
    transform: "translate(22.787 17.462)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.495,35.382a2.184,2.184,0,1,1,1.542-.64A2.182,2.182,0,0,1,85.495,35.382Zm0-4a1.82,1.82,0,1,0,1.285.533A1.818,1.818,0,0,0,85.495,31.383Z",
    transform: "translate(14.547 5.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.163,63.4a2.184,2.184,0,1,1,1.542-.64A2.182,2.182,0,0,1,44.163,63.4Zm0-4a1.82,1.82,0,1,0,1.285.533A1.819,1.819,0,0,0,44.163,59.4Z",
    transform: "translate(7.33 10.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.895,18.357a2.184,2.184,0,1,1,1.542-.64A2.182,2.182,0,0,1,25.895,18.357Zm0-4a1.82,1.82,0,1,0,1.285.533A1.819,1.819,0,0,0,25.895,14.358Z",
    transform: "translate(4.141 2.444)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.8e0c17a5c31400a3090440e324d60d3b.svg";
export { ForwardRef as ReactComponent };